import { ticketDeleteDescription as description } from './description';
import { deleteTicket as execute } from './execute';

export { description, execute };
